<!-- <i class="mi mi-close float-end d-inline dialog-close" mat-dialog-close></i> -->
<h4 mat-dialog-title>
  <span class=""> {{'pages.placeholders.Subject' | translate }}:</span> {{ messageData.subject }}
  <span class="float-end"> {{ messageData.createdDttm | date }}</span>
</h4>
<hr>
<mat-dialog-content class="mat-typography">
  {{ messageData.message }}
  <!-- {{messageData | json}} -->
  <p *ngIf="messageData.messageFilePath">
    attachment url:
    <a
      href="{{ messageData.messageFilePath }}"
      target="new"
      class="text-info cur-point text-underline"
      >{{ messageData.messageFilePath }}</a
    >
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close><span translate>pages.newRetailer.close</span></button>
</mat-dialog-actions>
